import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import styled from "styled-components";
import {useSelector} from "react-redux";
import {getLocale} from "../../../store/localization/selectors";
import {getConfig} from "./../../../store/settings/selectors";
import {useTheme} from "../../../themes";
import Image from "./../../../components/App/Image";
import Proportional from "./../../../components/App/Proportional";
import Loading from "./../../../components/App/Loading";


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const ImageCnt = styled.div`
  border-radius: 5px;
  overflow: hidden;
`;
const Upper = styled.div`
  color: #7B3572;
  font-size: 10px;
  margin-top: 5px;
`;
const Title = styled.div`
  color: #000000;
  font-size: 14px;
  margin-top: 10px;
  font-weight: 600;
`;
// const Lower = styled.div`
// `;

export default function HomeProduct({item = null, size = "normal", onClick = () => null}){

  const lang = useSelector(getLocale);
  const config = useSelector(getConfig);
  const theme = useTheme();
  const product = item;

  const cdnSrc = product && product.options.imageId
    ? config.ozwol.cdn + "/VPLUS-HOME/" + product.options.imageId.src.substr(0, product.options.imageId.src.lastIndexOf(".")).substr(product.options.imageId.src.lastIndexOf("/") + 1) + ".png"
    : null;
  const [imgSrc, setImgSrc] = useState(cdnSrc || (product && product.options.imageId ? product.options.imageId.src : null));

  return (
    <Wrapper>
      {product ?
        <Link onClick={onClick} to={"/"+lang+"/products/"+product.type+"s/"+product.id}>
          <ImageCnt>
            <Proportional ratio={size === "big" ? 0.75 : 1}>
              <Image
                src={imgSrc || theme.placeholders.product}
                height={{"value": 100, "unit": "%"}}
                width={{"value": 100, "unit": "%"}}
                fit={"contain"}
                onError={cdnSrc && imgSrc === cdnSrc && product.options.imageId ? () => setImgSrc(product.options.imageId.src) : undefined}
              />
            </Proportional>
          </ImageCnt>
          <Upper>{product.options.exhibitor.name}</Upper>
          <Title>{product.options.name}</Title>
          {/*<Lower>{ReactHtmlParser(product.lowertext)}</Lower>*/}
        </Link>
      :
        <Loading/>
      }
    </Wrapper>
  );

}
